/* bj-base.js — shared behaviour for babajo sections */
(function(){
  /* scroll reveal */
  var io = new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
  }, {threshold:.12});
  function bindReveal(){ document.querySelectorAll('.bj-rv:not(.in)').forEach(function(el){ io.observe(el); }); }
  document.addEventListener('DOMContentLoaded', bindReveal);
  document.addEventListener('shopify:section:load', bindReveal); /* re-bind in Theme Editor */

  /* countdown rolls to end of day (always live for demo/urgency) */
  function tickAll(){
    document.querySelectorAll('[data-bj-clock]').forEach(function(clock){
      var now = new Date(), end = new Date(now); end.setHours(23,59,59,999);
      var d = Math.max(0,(end-now)/1000);
      var h=String(Math.floor(d/3600)).padStart(2,'0');
      var m=String(Math.floor(d%3600/60)).padStart(2,'0');
      var s=String(Math.floor(d%60)).padStart(2,'0');
      var H=clock.querySelector('[data-h]'),M=clock.querySelector('[data-m]'),S=clock.querySelector('[data-s]');
      if(H)H.textContent=h; if(M)M.textContent=m; if(S)S.textContent=s;
    });
  }
  tickAll(); setInterval(tickAll,1000);

  /* PDP gallery */
  document.addEventListener('click', function(e){
    var thumb = e.target.closest('[data-bj-thumb]');
    if(thumb){
      var main = document.querySelector('[data-bj-main-img]');
      if(main){ main.src = thumb.getAttribute('data-full') || thumb.src; }
      document.querySelectorAll('[data-bj-thumb]').forEach(function(t){t.classList.remove('active');});
      thumb.classList.add('active');
    }
    /* qty stepper */
    var step = e.target.closest('[data-bj-step]');
    if(step){
      var input = step.parentElement.querySelector('input');
      var v = parseInt(input.value||'1',10);
      v += (step.getAttribute('data-bj-step')==='up'?1:-1);
      input.value = Math.max(1,v);
    }
  });
})();
